module.exports = __webpack_public_path__ + "img/photo-09.f9af1b03.jpg";